import { render, staticRenderFns } from "./PolitiqueDonnees.vue?vue&type=template&id=79ad322e&scoped=true"
var script = {}
import style0 from "./PolitiqueDonnees.vue?vue&type=style&index=0&id=79ad322e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad322e",
  null
  
)

export default component.exports